import {Box} from "@amzn/awsui-components-react";
import React from "react";

export const ValueWithLabel = ({label, children}) => (
  <div>
    <Box variant="awsui-key-label">{label}</Box>
    <div>{children}</div>
  </div>
);